import React from "react";

interface Props {
  size?: number;
  color?: string;
}

export function FollowingIcon(props: Props): React.ReactElement {
  const { size = 20, color = "black", ...rest } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_4139_1762)">
        <path
          d="M7.5 10C8.48891 10 9.45561 9.70676 10.2779 9.15735C11.1001 8.60794 11.741 7.82705 12.1194 6.91342C12.4978 5.99979 12.5969 4.99446 12.4039 4.02455C12.211 3.05465 11.7348 2.16373 11.0355 1.46447C10.3363 0.765206 9.44536 0.289002 8.47545 0.0960758C7.50555 -0.0968503 6.50021 0.00216643 5.58658 0.380605C4.67295 0.759043 3.89206 1.39991 3.34265 2.22215C2.79324 3.0444 2.5 4.0111 2.5 5C2.50132 6.32568 3.02853 7.59668 3.96593 8.53407C4.90332 9.47147 6.17432 9.99868 7.5 10ZM7.5 1.66667C8.15927 1.66667 8.80374 1.86217 9.3519 2.22844C9.90007 2.59471 10.3273 3.1153 10.5796 3.72439C10.8319 4.33348 10.8979 5.0037 10.7693 5.6503C10.6407 6.29691 10.3232 6.89085 9.85702 7.35702C9.39085 7.8232 8.79691 8.14067 8.1503 8.26929C7.5037 8.3979 6.83348 8.33189 6.22439 8.0796C5.6153 7.82731 5.09471 7.40007 4.72843 6.8519C4.36216 6.30374 4.16667 5.65927 4.16667 5C4.16667 4.11595 4.51786 3.2681 5.14298 2.64298C5.7681 2.01786 6.61595 1.66667 7.5 1.66667V1.66667Z"
          fill={color}
        />
        <path
          d="M7.5 11.6664C5.51162 11.6688 3.60538 12.4598 2.19938 13.8658C0.793381 15.2717 0.0024258 17.178 0 19.1664C0 19.3874 0.0877974 19.5993 0.244078 19.7556C0.400358 19.9119 0.61232 19.9997 0.833333 19.9997C1.05435 19.9997 1.26631 19.9119 1.42259 19.7556C1.57887 19.5993 1.66667 19.3874 1.66667 19.1664C1.66667 17.6193 2.28125 16.1355 3.37521 15.0416C4.46917 13.9476 5.9529 13.333 7.5 13.333C9.0471 13.333 10.5308 13.9476 11.6248 15.0416C12.7188 16.1355 13.3333 17.6193 13.3333 19.1664C13.3333 19.3874 13.4211 19.5993 13.5774 19.7556C13.7337 19.9119 13.9457 19.9997 14.1667 19.9997C14.3877 19.9997 14.5996 19.9119 14.7559 19.7556C14.9122 19.5993 15 19.3874 15 19.1664C14.9976 17.178 14.2066 15.2717 12.8006 13.8658C11.3946 12.4598 9.48838 11.6688 7.5 11.6664V11.6664Z"
          fill={color}
        />
        <path
          d="M18.3332 6.5625C17.8694 6.5856 17.4337 6.79147 17.1214 7.13506C16.809 7.47864 16.6455 7.93197 16.6666 8.39583C16.6876 7.93197 16.5241 7.47864 16.2117 7.13506C15.8994 6.79147 15.4637 6.5856 14.9999 6.5625C14.5361 6.5856 14.1004 6.79147 13.788 7.13506C13.4757 7.47864 13.3122 7.93197 13.3332 8.39583C13.3332 9.8375 15.2132 11.5267 16.1499 12.2783C16.2965 12.3957 16.4787 12.4597 16.6666 12.4597C16.8544 12.4597 17.0366 12.3957 17.1832 12.2783C18.1199 11.5283 19.9999 9.8375 19.9999 8.39583C20.0209 7.93197 19.8574 7.47864 19.5451 7.13506C19.2327 6.79147 18.797 6.5856 18.3332 6.5625V6.5625Z"
          fill={color}
        />
      </g>
    </svg>
  );
}
